<template>

  <div>
    <!-- Filters -->
    <list-filters
      :kanwil-filter.sync="kanwilFilter"
      :upt-filter.sync="uptFilter"
      :kanwilOptions="kanwilOptions.options"
      :uptOptions="uptOptions.options"
      @emitReceiverUPT="reloadUPTOptions"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                variant="primary"
                @click="openConfirmationModal"
                v-if="$can('sinkronisasi', 'sinkronisasi-upt')"
              >
                <span class="text-nowrap">Sinkronisasi UPT </span>
              </b-button>
            </div>
          </b-col>
        </b-row>

        <b-modal ref="confirmModal" title="Konfirmasi" @ok="sinkronisasiUPT" no-close-on-backdrop centered>
          <template>
            Apakah Anda yakin ingin melakukan sinkronisasi UPT?
          </template>
        </b-modal>
        <b-modal ref="spinnerModal" title="Loading" hide-footer hide-header-close no-close-on-backdrop centered>
          <template>
            <div class="text-center">
              <p>Sedang Dilakukan Sinkronisasi....</p>
              <b-spinner v-if="loading" label="Memuat..." variant="primary"></b-spinner>
            </div>
          </template>
        </b-modal>
      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchDatas"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(email)="data">
          <b-media vertical-align="center">
            {{ data.item.email }}
          </b-media>
        </template>

        <template #cell(role)="data">
          <b-media vertical-align="center">
            {{ data.item.role }}
          </b-media>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Menampilkan {{ dataMeta.from }} per {{ dataMeta.to }} dari {{ dataMeta.of }} data </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar,
  BBadge, BDropdown, BDropdownItem, BPagination, BModal, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  getKanwil,
  getUPT,
} from '@/connection-api/master'
import {
  sinkronisasiUPT,
} from '@/api/user'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/connection-api/sinkronisasi-upt/storeModule'
import useList from '@/connection-api/sinkronisasi-upt/list'
import listFilters from './ListFilters.vue'

export default {
  components: {
    listFilters,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    // BDropdown,
    // BDropdownItem,
    BPagination,
    BModal,
    BSpinner,
    vSelect,
  },
  data() {
    return {
      kanwilOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Kanwil --' },
        ],
      },
      uptOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih UPT --' },
        ],
      },
      loading: false,
    }
  },
  async mounted() {
    const responseKanwilOptions = await getKanwil()
    this.mappingSelectOption(responseKanwilOptions.data, this.kanwilOptions.options)
    this.reloadUPTOptions()
  },
  methods: {
    makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Registrasi',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    emitAddError(response) {
      this.makeToast('danger', response.data.data)
    },
    async reloadUPTOptions(kanwilId) {
      this.uptFilter = null
      this.uptOptions = {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih UPT --' },
        ],
      }
      const responseUptOptions = await getUPT(kanwilId)
      this.mappingSelectOption(responseUptOptions.data, this.uptOptions.options)
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
    mappingSelectOptionRole(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.name,
            value: element.guard_name,
          })
        })
      }
    },
    openConfirmationModal() {
      this.$refs.confirmModal.show()
    },
    closeConfirmationModal() {
      this.$refs.confirmModal.hide()
    },
    async sinkronisasiUPT() {
      this.loading = true // Aktifkan loading
      this.$refs.spinnerModal.show()
      const response = await sinkronisasiUPT()
      if (response.data.message === 'error') {
        this.$refs.spinnerModal.hide()
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: 'Gagal Proses Sinkronisasi Data UPT!',
          },
        })
      } else if (response.data.message === 'success') {
        this.$refs.spinnerModal.hide()
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Sukses',
            icon: 'CoffeeIcon',
            variant: 'success',
            text: 'Data berhasil disinkronisasikan',
          },
        })
        this.$router.go()
      } else if (response.data.message === 'error_auth') {
        this.$refs.spinnerModal.hide()
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: 'Gagal Proses Sinkronisasi Data UPT, Dikarenakan Anda Bukan Admin!',
          },
        })
      }
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'sinkronisasi-upt'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)

    const {
      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      kanwilFilter,
      uptFilter,
      roleFilter,
    } = useList()

    return {

      // Sidebar
      isAddNewUserSidebarActive,

      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      kanwilFilter,
      uptFilter,
      roleFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
